/**
*
*   Signup Footer
*       - The Signup Area on the Footer
*
**/
'use client';

import Button from '@/components/button';
import Article from '@/libraries/article';


//Build the Element
export default function Tags({ article, type = 'sage' , size = 'narrow', ...props }){

	//Return
	return (
		<nav className="tags">
			{ article.tags.map( tag => (
				<Button key={ tag } href={ `/blog/${  article.blog.handle  }/tagged/${  Article.handle( tag ) }` } type={ type } size={ size }>
					{ tag }
				</Button>
			))}
		</nav>
	);

}